// import { useEffect } from "react";
// import { useTypedDispatch } from "../../hooks/useTypedDispatch";
// import { setToastState } from "../../redux/reducers/globalState";

export function ErrorFallback(/* {
  error,
  resetErrorBoundary,
}: {
  error: Error;
  resetErrorBoundary: () => void;
} */) {
  // const dispatch = useTypedDispatch();

  // useEffect(() => {
  //   dispatch(
  //     setToastState({
  //       variant: "error",
  //       shouldShow: true,
  //       message: {
  //         title: "Erro inesperado",
  //         description: "Recarregue a página e tente novamente.",
  //       },
  //     })
  //   );
  // }, [dispatch]);

  return <></>;
}